export const data9_4 = [{
    name: "Machinery Equipment 机器设备",
    name_code: "Machinery_Equipment",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Furniture & Fixture 家具及摆设",
    name_code: "Furniture_Fixture",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Transportation and communication equipment 交通运输设备",
    name_code: "Transportation_and_communication_equipment",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Electrical and electronic equipment 电子电器设备",
    name_code: "Electrical_and_electronic_equipment",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Others 其他设备",
    name_code: "Others",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}, {
    name: "Total",
    name_code: "Total",
    system: "0",
    stock: "0",
    diff: "0",
    percent: "0",
    note: ""
}]


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-5/data.js